<template>
  <div class="flex flex-col items-center m-5 text-white">
    <div class="mt-20">
      <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="smile" class="w-32 h-32" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
        <path
          fill="currentColor"
          d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"
        ></path>
      </svg>
    </div>
    <div class="mt-5 font-bold">
      Su registro ha sido exitoso.
    </div>
    <div class="mt-5 text-sm">
      Aguarde el mail en su casilla de correo con el link de activación y luego inicie sesión en la app
    </div>
    <div>
      <button>
        <button @click="ok" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Ok</button>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    ok() {
      this.$router.push("/");
    }
  }
};
</script>
